import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3be47bc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workouts-list" }
const _hoisted_2 = { class: "total" }
const _hoisted_3 = { class: "total-label" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "workouts-table responsive-table"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "sport-col" }, null, -1))
const _hoisted_7 = { class: "sport-col" }
const _hoisted_8 = { class: "cell-heading" }
const _hoisted_9 = ["onMouseover"]
const _hoisted_10 = { class: "cell-heading" }
const _hoisted_11 = {
  key: 0,
  class: "fa fa-map-o",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "cell-heading" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = { class: "cell-heading" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { class: "cell-heading" }
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = { class: "cell-heading" }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = { class: "cell-heading" }
const _hoisted_21 = { class: "text-right" }
const _hoisted_22 = { class: "cell-heading" }
const _hoisted_23 = { class: "text-right" }
const _hoisted_24 = { class: "cell-heading" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "bottom" }, null, -1))

import { format } from 'date-fns'
  import {
    ComputedRef,
    Ref,
    computed,
    ref,
    toRefs,
    watch,
    capitalize,
    onBeforeMount,
  } from 'vue'
  import { LocationQuery, useRoute, useRouter } from 'vue-router'

  import FilterSelects from '@/components/Common/FilterSelects.vue'
  import Pagination from '@/components/Common/Pagination.vue'
  import StaticMap from '@/components/Common/StaticMap.vue'
  import NoWorkouts from '@/components/Workouts/NoWorkouts.vue'
  import { WORKOUTS_STORE } from '@/store/constants'
  import { IPagination } from '@/types/api'
  import { ITranslatedSport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { IWorkout, TWorkoutsPayload } from '@/types/workouts'
  import { useStore } from '@/use/useStore'
  import { getQuery, sortList, workoutsPayloadKeys } from '@/utils/api'
  import { getDateWithTZ } from '@/utils/dates'
  import { getSportColor, getSportLabel } from '@/utils/sports'
  import { convertDistance } from '@/utils/units'
  import { defaultOrder } from '@/utils/workouts'

  interface Props {
    user: IUserProfile
    sports: ITranslatedSport[]
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    sports: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
    sports: ITranslatedSport[]
  }

  

  const store = useStore()
  const route = useRoute()
  const router = useRouter()

  const { user, sports } = toRefs(props)
  const orderByList: string[] = [
    'ave_speed',
    'distance',
    'duration',
    'workout_date',
  ]
  const workouts: ComputedRef<IWorkout[]> = computed(
    () => store.getters[WORKOUTS_STORE.GETTERS.USER_WORKOUTS]
  )
  const pagination: ComputedRef<IPagination> = computed(
    () => store.getters[WORKOUTS_STORE.GETTERS.WORKOUTS_PAGINATION]
  )
  let query: TWorkoutsPayload = getWorkoutsQuery(route.query)
  const hoverWorkoutId: Ref<string | null> = ref(null)

  onBeforeMount(() => {
    loadWorkouts(query)
  })

  function loadWorkouts(payload: TWorkoutsPayload) {
    store.dispatch(
      WORKOUTS_STORE.ACTIONS.GET_USER_WORKOUTS,
      user.value.imperial_units ? getConvertedPayload(payload) : payload
    )
  }
  function reloadWorkouts(queryParam: string, queryValue: string) {
    const newQuery: LocationQuery = Object.assign({}, route.query)
    newQuery[queryParam] = queryValue
    if (queryParam === 'per_page') {
      newQuery['page'] = '1'
    }
    query = getWorkoutsQuery(newQuery)
    router.push({ path: '/workouts', query })
  }

  function getWorkoutsQuery(newQuery: LocationQuery): TWorkoutsPayload {
    let workoutQuery = getQuery(newQuery, orderByList, defaultOrder.order_by, {
      defaultSort: defaultOrder.order,
    })
    Object.keys(newQuery)
      .filter((k) => workoutsPayloadKeys.includes(k))
      .map((k) => {
        if (typeof newQuery[k] === 'string') {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          workoutQuery[k] = newQuery[k]
        }
      })
    return workoutQuery
  }

  function getConvertedPayload(payload: TWorkoutsPayload): TWorkoutsPayload {
    const convertedPayload: TWorkoutsPayload = {
      ...payload,
    }
    Object.entries(convertedPayload).map((entry) => {
      if (entry[0].match('speed|distance')) {
        convertedPayload[entry[0]] = convertDistance(+entry[1], 'mi', 'km')
      }
    })
    return convertedPayload
  }

  function onHover(workoutId: string | null) {
    hoverWorkoutId.value = workoutId
  }

  watch(
    () => route.query,
    async (newQuery) => {
      query = getWorkoutsQuery(newQuery)
      loadWorkouts(query)
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_SportImage = _resolveComponent("SportImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Distance = _resolveComponent("Distance")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["box", { 'empty-table': _unref(workouts).length === 0 }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.TOTAL').toLowerCase()) + ": ", 1),
        (_unref(pagination).total !== null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(pagination).total) + " " + _toDisplayString(_ctx.$t('workouts.WORKOUT', _unref(pagination).total)), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(FilterSelects, {
        sort: _unref(sortList),
        order_by: orderByList,
        query: _unref(query),
        message: "workouts",
        onUpdateSelect: reloadWorkouts
      }, null, 8, ["sort", "query"]),
      (_unref(workouts).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(Pagination, {
              class: "top-pagination",
              pagination: _unref(pagination),
              path: "/workouts",
              query: _unref(query)
            }, null, 8, ["pagination", "query"]),
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_6,
                  _createElementVNode("th", null, _toDisplayString(capitalize(_ctx.$t('workouts.WORKOUT', 1))), 1),
                  _createElementVNode("th", null, _toDisplayString(capitalize(_ctx.$t('workouts.DATE'))), 1),
                  _createElementVNode("th", null, _toDisplayString(capitalize(_ctx.$t('workouts.DISTANCE'))), 1),
                  _createElementVNode("th", null, _toDisplayString(capitalize(_ctx.$t('workouts.DURATION'))), 1),
                  _createElementVNode("th", null, _toDisplayString(capitalize(_ctx.$t('workouts.AVE_SPEED'))), 1),
                  _createElementVNode("th", null, _toDisplayString(capitalize(_ctx.$t('workouts.MAX_SPEED'))), 1),
                  _createElementVNode("th", null, _toDisplayString(capitalize(_ctx.$t('workouts.ASCENT'))), 1),
                  _createElementVNode("th", null, _toDisplayString(capitalize(_ctx.$t('workouts.DESCENT'))), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workouts), (workout) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: workout.id
                  }, [
                    _createElementVNode("td", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('workouts.SPORT', 1)), 1),
                      (_unref(sports).length > 0)
                        ? (_openBlock(), _createBlock(_component_SportImage, {
                            key: 0,
                            title: 
                    _unref(sports).find((s) => s.id === workout.sport_id)
                      .translatedLabel
                  ,
                            "sport-label": _unref(getSportLabel)(workout, _unref(sports)),
                            color: _unref(getSportColor)(workout, _unref(sports))
                          }, null, 8, ["title", "sport-label", "color"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", {
                      class: "workout-title",
                      onMouseover: ($event: any) => (onHover(workout.id)),
                      onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (onHover(null)))
                    }, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(capitalize(_ctx.$t('workouts.WORKOUT', 1))), 1),
                      _createVNode(_component_router_link, {
                        class: "nav-item",
                        to: { name: 'Workout', params: { workoutId: workout.id } }
                      }, {
                        default: _withCtx(() => [
                          (workout.with_gpx)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(workout.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      (workout.with_gpx && hoverWorkoutId.value === workout.id)
                        ? (_openBlock(), _createBlock(StaticMap, {
                            key: 0,
                            workout: workout,
                            "display-hover": true
                          }, null, 8, ["workout"]))
                        : _createCommentVNode("", true)
                    ], 40, _hoisted_9),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('workouts.DATE')), 1),
                      _createTextVNode(" " + _toDisplayString(_unref(format)(
                    _unref(getDateWithTZ)(workout.workout_date, _unref(user).timezone),
                    'dd/MM/yyyy HH:mm'
                  )), 1)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('workouts.DISTANCE')), 1),
                      _createVNode(_component_Distance, {
                        distance: workout.distance,
                        unitFrom: "km",
                        useImperialUnits: _unref(user).imperial_units
                      }, null, 8, ["distance", "useImperialUnits"])
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('workouts.DURATION')), 1),
                      _createTextVNode(" " + _toDisplayString(workout.moving), 1)
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('workouts.AVE_SPEED')), 1),
                      _createVNode(_component_Distance, {
                        distance: workout.ave_speed,
                        unitFrom: "km",
                        speed: true,
                        useImperialUnits: _unref(user).imperial_units
                      }, null, 8, ["distance", "useImperialUnits"])
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('workouts.MAX_SPEED')), 1),
                      _createVNode(_component_Distance, {
                        distance: workout.max_speed,
                        unitFrom: "km",
                        speed: true,
                        useImperialUnits: _unref(user).imperial_units
                      }, null, 8, ["distance", "useImperialUnits"])
                    ]),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('workouts.ASCENT')), 1),
                      (workout.with_gpx)
                        ? (_openBlock(), _createBlock(_component_Distance, {
                            key: 0,
                            distance: workout.ascent,
                            unitFrom: "m",
                            useImperialUnits: _unref(user).imperial_units
                          }, null, 8, ["distance", "useImperialUnits"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('workouts.DESCENT')), 1),
                      (workout.with_gpx)
                        ? (_openBlock(), _createBlock(_component_Distance, {
                            key: 0,
                            distance: workout.descent,
                            unitFrom: "m",
                            useImperialUnits: _unref(user).imperial_units
                          }, null, 8, ["distance", "useImperialUnits"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createVNode(Pagination, {
              pagination: _unref(pagination),
              path: "/workouts",
              query: _unref(query)
            }, null, 8, ["pagination", "query"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_unref(workouts).length === 0)
      ? (_openBlock(), _createBlock(NoWorkouts, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_25
  ]))
}
}

})